import { createContext, useContext } from 'react'

export interface FlashContextValue {
  showSuccessFlash: (message: string) => void
  showErrorFlash: (message: string) => void
}

const FlashContext = createContext<FlashContextValue | undefined>(undefined)

export const useFlash = (): FlashContextValue => {
  const ctx = useContext(FlashContext)
  if (!ctx) throw new Error('useFlash must be used inside FlashProvider')
  return ctx
}

export default FlashContext
